//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  caption: {
    color: theme.palette.text.secondary,
  },
});
const WelcomePage = ({ classes }) => {
  return (
    <React.Fragment>
      <div className={classes.caption}>
        <h3>P6-Loader</h3>
        <hr />
        <p>
          Automate Primavera P6 data loading and updating. Import and export
          data back and forth between Primavera P6 and Microsoft Excel with
          ease.
        </p>
        <ul>
          <li>
            P6-Loader cloud enabled and Oracle Cloud Marketplace approved{" "}
          </li>
          <li>
            {" "}
            <a href="https://www.emerald-associates.com/category/p6-loader.html">
              P6-Loader Blog - Tips
            </a>
            , tricks and use cases on how we've automated P6 data entry{" "}
          </li>
          <li>
            {" "}
            Easily update Primavera P6 with data that exists in other locations
          </li>
          <li> Give contractors ready-to-load Excel templates to fill in</li>
          <li>
            {" "}
            Import and export global and project data with hierarchy and logic
            between Microsoft Excel and Primavera P6{" "}
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};
export default withStyles(styles)(WelcomePage);
